
import { createWebHistory, createRouter } from "vue-router";

const routes = [
    {
        path: "/",
        alias: "/login",
        name: "login",
        component: () => import("./components/Login")
    },
    {
        path: "/forgot-password",
        name: "forgot-password",
        component: () => import("./components/ForgotPassword")
    },
    {
        path: "/reset-password/:userId/:resetToken",
        name: "reset-password",
        component: () => import("./components/ResetPassword")
    },
    {
        path: "/initial-password",
        name: "initial-password",
        component: () => import("./components/InitialPassword")
    },
    {
        path: "/url/overview",
        name: "url-overview",
        component: () => import("./components/Overview")
    },
    {
        path: "/url/read/:id",
        name: "url-read",
        component: () => import("./components/Read")
    },
    {
        path: "/url/create",
        name: "url-create",
        component: () => import("./components/CreateUpdate"),
        props: {
            update: false
        }
    },
    {
        path: "/url/update/:id",
        name: "url-update",
        component: () => import("./components/CreateUpdate"),
        props: {
            update: true
        }
    },
    {
        path: "/url/statistics/:id",
        name: "url-statistics",
        component: () => import("./components/Statistics"),
        props: {
            update: true
        }
    },
    {
        path: "/url/history/:id",
        name: "url-history",
        component: () => import("./components/History"),
        props: {
            update: true
        }
    },
    {
        path: "/url/logs/:id",
        name: "url-logs",
        component: () => import("./components/Logs"),
        props: {
            update: true
        }
    }
];
const router = createRouter({
    history: createWebHistory(),
    base: process.env.NODE_ENV === 'development' ? '/urlshortener' : '/admin/',
    routes,
});

router.beforeEach((to, from, next) => {
    if (to.name !== 'login' && !localStorage.getItem('token')) next({ name: 'login' })
    else next()
});

export default router;